// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604141919/js/" + chunkId + "." + {"44":"bd92d2fd","225":"0a6204ea","481":"3cfa534e","486":"bd4897e1","770":"26fe5aad"}[chunkId] + ".0.3336565566733185.chunk.js";
};